<template>
  <div>
    <label :for="uuid" v-html="labelHtml" class="label" />
    <input
      :type="type"
      :value="modelValue"
      :required="required"
      :id="uuid"
      :disabled="readOnly"
      @input="update($event.target.value)"
      v-bind="$attrs"
      @keypress="onlyNumber"
      :class="fieldClasses.input"
    />
    <p v-show="validation.errorMessage" v-text="validation.errorMessage"></p>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: { required: true },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      default: () => ({ type: "text" })
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: Number,
      default: 0
    },
    validation: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: "text"
    },
    isInteger: Boolean,
    validations: {
      type: Object,
      default: () => ({})
    },
    fieldClasses: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    labelHtml() {
      const requiredHtml =
        (this.validations._exclusive && this.validations._exclusive.required) ||
        _.includes(this.validations, "required")
          ? "" // ' <span class="label--required">*</span>'
          : "";
      return this.label + requiredHtml;
    }
  },
  methods: {
    update(value) {
      this.$emit("update:modelValue", value);
    },
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      if (this.isInteger === true) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode < 48 || keyCode > 57) {
          // 46 is dot
          $event.preventDefault();
        }
      }
    }
  }
};
</script>
